document.addEventListener("DOMContentLoaded", function() {

  

  function addProductToCart(id){
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: { quantity: 1, id: id },
      success: function(itemData) {
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: id,
            quantity: 1
          }
        }));
        // getCartItems();
      },
      error: function(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        console.log("Error: " + response);
      }
    });
  }

  collectionSizeFn = function(e){
    e.preventDefault();
    var form = $(e.target).closest('form');
    var values = {};
    $.each(form.serializeArray(), function (i, field) {
      values[field.name] = field.value;		
    });
    var getValue = function (valueName) {
      return values[valueName];
    };

    var id = $(e.target).siblings('input.size-block').attr('value');

    if(id != undefined && id != null){
      addProductToCart(id);
    } else {
      alert("Please select a size");
    }
  }

  $(document).on('click', '.size-add-to-cart', collectionSizeFn);
  
})